import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const SecondaryNavContext = createContext({ nav: null, setNav: () => {} });

export const SecondaryNavProvider = ({ children }) => {
  const [nav, setNav] = useState(null);
  const value = useMemo(() => ({ nav, setNav }), [nav]);
  return (
    <SecondaryNavContext.Provider value={value}>
      {children}
    </SecondaryNavContext.Provider>
  );
};

export const useSecondaryNav = () => useContext(SecondaryNavContext);

export const useProvideSecondaryNav = (nav) => {
  const { setNav } = useSecondaryNav();

  useEffect(() => {
    setNav(nav);
    return () => setNav(null);
  }, [nav, setNav]);
};

export default SecondaryNavContext;
